import React, { useEffect, useState } from "react";
import useSizePercentage from "../hooks/useSizePercentage";

const EstimateTime = ({ onTimeEntered, timeValue }) => {
  const [times, setTimes] = useState({
    months: 0,
    weeks: 0,
    days: 0,
    hours: 0,
    minutes: 0,
  });

  function timeValueToTimesObject(timeValue) {
    const months = Math.floor(timeValue / 43800);
    const weeks = Math.floor((timeValue - months * 43800) / 10080);
    const days = Math.floor(
      (timeValue - months * 43800 - weeks * 10080) / 1440
    );
    const hours = Math.floor(
      (timeValue - months * 43800 - weeks * 10080 - days * 1440) / 60
    );
    const minutes =
      timeValue - months * 43800 - weeks * 10080 - days * 1440 - hours * 60;
    setTimes({ months, weeks, days, hours, minutes });
  }

  useEffect(() => {
    timeValueToTimesObject(timeValue);
  }, []);

  useEffect(() => {
    const totalMinutes =
      times.minutes +
      times.hours * 60 +
      times.days * 1440 +
      times.weeks * 10080 +
      times.months * 43800;
    onTimeEntered(totalMinutes);
  }, [times]);
  const spans = ["months", "weeks", "days", "hours", "minutes"];
  return (
    <div
      className="divRow"
      style={{ width: "100%", justifyContent: "space-around" }}
    >
      {spans.map((s) => (
        <TimeInput timespan={s} times={times} setTimes={setTimes} key={s} />
      ))}
    </div>
  );
};

const TimeInput = ({ timespan, times, setTimes }) => {
  const handleFocus = (event) => event.target.select();
  return (
    <div className="divRow">
      <div className="textBold">{timespan}</div>
      <input
        maxLength={2}
        onFocus={handleFocus}
        type={"number"}
        style={{
          width: "25px",
          textAlign: "center",
          height: "20px",
          fontSize: "20px",
          fontFamily: "Roboto-Bold",
          appearance: "none",
        }}
        value={times[timespan]}
        onChange={(e) => {
          setTimes({
            ...times,
            [timespan]:
              e.target.value.length > 0 ? parseInt(e.target.value) : 0,
          });
        }}
      />
    </div>
  );
};

export default EstimateTime;
